


export class CADO {
  "exception";
  "nameOfEmployeeOrApplicant";
  "personnelNumber";
  "senderCostCenter";
  "date";
  "hours";
  "receiverOrder";
  "network";
  "activityType";
  "operationActivity";
  "attAbsenceType";
  "shortText";
  "projectManagerStatusText";
  "approvedByProjectManager";
  "lastChange";
  "createdOn";
  "createdBy";
  "changedBy";
  "name";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CADO`.
   */
  static getModelName() {
    return "CADO";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CADO for dynamic purposes.
  **/
  static factory(data) {
    return new CADO(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'CADO',
      plural: 'CADOs',
      path: 'CADOs',
      properties: {
        "exception": {
          name: 'exception',
          type: 'string'
        },
        "nameOfEmployeeOrApplicant": {
          name: 'nameOfEmployeeOrApplicant',
          type: 'string'
        },
        "personnelNumber": {
          name: 'personnelNumber',
          type: 'string'
        },
        "senderCostCenter": {
          name: 'senderCostCenter',
          type: 'string'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "hours": {
          name: 'hours',
          type: 'string'
        },
        "receiverOrder": {
          name: 'receiverOrder',
          type: 'string'
        },
        "network": {
          name: 'network',
          type: 'string'
        },
        "activityType": {
          name: 'activityType',
          type: 'string'
        },
        "operationActivity": {
          name: 'operationActivity',
          type: 'string'
        },
        "attAbsenceType": {
          name: 'attAbsenceType',
          type: 'string'
        },
        "shortText": {
          name: 'shortText',
          type: 'string'
        },
        "projectManagerStatusText": {
          name: 'projectManagerStatusText',
          type: 'string'
        },
        "approvedByProjectManager": {
          name: 'approvedByProjectManager',
          type: 'string'
        },
        "lastChange": {
          name: 'lastChange',
          type: 'Date'
        },
        "createdOn": {
          name: 'createdOn',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "changedBy": {
          name: 'changedBy',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/CADO.js